import { ActionTree } from 'vuex';
import {ViolationState} from './types';
import { RootState } from '@/store/types';
import Vue from 'vue';
import * as _ from 'lodash';
import { MAFUser } from '@/store/User/types';
import { MAFViolation} from '@/store/Violations/types';
import * as firebase from 'firebase/app';
import QuerySnapshot = firebase.firestore.QuerySnapshot;
import QueryDocumentSnapshot = firebase.firestore.QueryDocumentSnapshot;
import DocumentSnapshot = firebase.firestore.DocumentSnapshot;
import { Lookup } from '@/store/types';

/* tslint:disable:no-console */

export const actions: ActionTree<ViolationState, RootState> = {
    getMAFViolations({ state, commit }) {
        Vue.prototype.$firestore.collection(`violations`).onSnapshot(async (snapshot: QuerySnapshot) => {
            const violation: MAFViolation[] = [];
            const done = _.after(snapshot.docs.length, () => {
                commit('setViolations', violation);
            });
            _.forEach(snapshot.docs, (document: QueryDocumentSnapshot) => {
                const vio: MAFViolation = new MAFViolation(document.data());
                // setting violation's document reference for editing resolution
                vio.setDocumentReference(document.ref);
                violation.push(vio);
                done();
                // vio.getUsers().then(() => {
                //     violation.push(vio);
                //     done();
                // });
            });
        }, (error: any) => {
            if (Vue.prototype.$auth.currentUser !== null) {
                console.log(`Error getting violations: ${error}`);
            }
        });
    },
    async getResolutions({ commit }): Promise<any> {
        try {
            const doc: DocumentSnapshot = await Vue.prototype.$firestore.collection('lookups').doc('resolutions').get();

            if (doc.exists) {
                commit('setResolutions', doc.data());
            }
        } catch (e) {
             console.log('Error getting document:', e);
        }
    },

    // UPDATE - MAF Violation with new resolution (admin)
    async updateMAFViolations({ state, commit }, violation: MAFViolation): Promise<any> {
        if ( violation.Reference ) {
            try {
                // update FireStore document reference
                return await violation.Reference.update(violation.toPlainObj());
            } catch (error) {
                console.log(error);
                return error;
            }
        } else {
            console.error('Violation does not have reference object');
        }
    },

    async getAllUsers({ state, commit }): Promise < any > {
        Vue.prototype.$firestore.collection('users').
        where('signUpPhase', '==', -1).onSnapshot(async (snapshot: QuerySnapshot) => {
            const users: MAFUser[] = [];
            for (const doc of snapshot.docs) {
                const mafUser = new MAFUser(doc.data());
                mafUser.setDocumentReference(doc.ref);
                users.push(mafUser);
            }
            commit('setAllUsers', users);
        }, (error: any) => {
            if (Vue.prototype.$auth.currentUser !== null) {
                console.log(`Error getting user: ${error}`);
            }
        });
    },
    // Create MAF Violations
    async reportFriend({commit, state}, violation: MAFViolation ): Promise<any> {
        return await Vue.prototype.$firestore.collection('violations').add(violation.toPlainObj());
    },
};
